import { render } from "./CustomCheckBox.vue?vue&type=template&id=e42d4bda&scoped=true"
import script from "./CustomCheckBox.vue?vue&type=script&lang=js"
export * from "./CustomCheckBox.vue?vue&type=script&lang=js"

import "./CustomCheckBox.vue?vue&type=style&index=0&id=e42d4bda&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e42d4bda"

export default script